<template>
  <svg
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="customStyle"
  >
    <path
      d="M8.99988 2.25006L14.9999 5.62506V12.3751L8.99988 15.7501L2.99988 12.3751V5.62506L8.99988 2.25006Z"
      stroke="#218579"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.99988 9.00006L14.9999 5.62506"
      stroke="#218579"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.99988 9.00006V15.7501"
      stroke="#218579"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.99988 9.00006L2.99988 5.62506"
      stroke="#218579"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'CubeIcon',

  props: {
    customStyle: {
      type: String,
      default: 'size-5',
    },
  },
}
</script>
